import { Typography } from '@mui/material';
import { Fragment } from 'react';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type SuperscriptProps = StructuredContentDocument;

export function Superscript({ props }: SuperscriptProps) {
  return (
    <Typography
      component="sup"
      sx={{
        fontSize: 'smaller',
        fontWeight: 'inherit',
        lineHeight: 0,
        verticalAlign: 'super',
      }}
    >
      {[props.children].flat().map((child, idx) => {
        if (typeof child === 'string') {
          return <Fragment key={idx}>{child}</Fragment>;
        }

        if (!child) {
          return null;
        }

        return <StructuredContentRenderer doc={child} key={idx} />;
      })}
    </Typography>
  );
}
